import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { HttpService } from '../../../services/http.service';
import { Colors } from '../../../models/enums/colors.enum';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() statusColor: string;
  @Input() statusInline: boolean = true;
  @Input() statusVisible: boolean = true;
  @Input() align: string = 'center';
  @Input() fontSize: number = 12;
  @Input() margin: string = '5px 0';

  @Input() systemId: string;
  @Input() subSystemId: string = null;

  activeStatusColor: string;

  subscription: ISubscription;

  constructor(private http: HttpService, private cdref: ChangeDetectorRef) { }

  ngOnInit() {
    this.activeStatusColor = this.statusColor;
    if (this.statusVisible){
      this.subscription = this.http.dashboardData().subscribe(data => {
        let filtered = data.filter(sys => sys.systemId == this.systemId && sys.subSystemId == this.subSystemId);
        if (filtered.length > 0){
          if (filtered[0].status == null){
            this.statusColor = Colors.lightGrey;
          }
          else if (filtered[0].status == false){
            this.statusColor = Colors.red;
            this.statusVisible = false;
          }
          else{ 
            this.statusColor = this.activeStatusColor;
          }
          this.cdref.detectChanges();
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/stats/title/title.component.ts